import { Pricing } from "@/shared/types/global-store"

export const runsOnServerSide = typeof window === "undefined"

/**
 * This function is a copy/paste from the french subscription flow
 * @returns a random user id
 */
export function generateUserId() {
  let userId = "DAL_" + Math.random().toString(36).substring(2, 4)
  userId += "_" + Date.now().toString()
  return userId
}

//https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
export function generatePetId() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

/**
 * Source: https://grafikart.fr/tutoriels/drapeau-emoji-fonction-2152
 * @param code fr, gb, de...
 * @returns the emoji flag (🇫🇷, 🇬🇧, 🇩🇪)
 */
export function isoToEmoji(code: string) {
  return code
    .split("")
    .map((letter) => (letter.charCodeAt(0) % 32) + 0x1f1e5)
    .map((emojiCode) => String.fromCodePoint(emojiCode))
    .join("")
}

// Source: https://www.freecodecamp.org/news/javascript-debounce-example/
export function debounce(func: (...args: any[]) => any, timeout = 100) {
  let timer: NodeJS.Timeout
  return (...args: any[]) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(args)
    }, timeout)
  }
}


type MaybeQuoteID = { context?: { meta?: { quote_id?: string; promo_code?: string } } }

export function getCurrentQuoteID() {
  if (runsOnServerSide) return

  const stateAsString = localStorage.getItem("flow-state") ?? "{}"
  const state = JSON.parse(stateAsString) as MaybeQuoteID

  return state?.context?.meta?.quote_id
}

export type ContextFromLocalStorage = {
  meta?: { quote_id?: string; promo_code?: string }
  owner?: {
    email: string
  }
  pets?: {
    type: "dog" | "cat"
    pricing: Pricing
  }[]
}

